import { Injectable, inject } from "@angular/core";
import { AbstractTransformer } from "../abstract-transformer";
import { Transform, TRANSFORM_TYPE } from "@pienso/ingest-types/transform.interface";
import { CorpusDataService, SampleTransformDetails, TransformDetails } from "../../services/corpus-data.service";
import { AlertService } from "@ui";
import { SampleService } from "./sample.service";
import { TransformerGridDataService } from "../transformer-grid-data.service";
import { ToolbarItem } from "../toolbar-item";
import { SampleToolbarComponent } from "./sample-toolbar.component";
import { TRANSFORMER_STATE } from "../abstract-transformer.service";

@Injectable({ providedIn: "root" })
export class SampleTransformerService extends AbstractTransformer {
  override service: SampleService;

  constructor() {
    const service = inject(SampleService);
    const dataService = inject(TransformerGridDataService);
    const corpusService = inject(CorpusDataService);
    const alertService = inject(AlertService);

    super(
      "sample",
      "Sample",
      [TRANSFORM_TYPE.SAMPLE_DATA],
      corpusService,
      alertService,
      service,
      dataService,
      new ToolbarItem(SampleToolbarComponent),
    );
    this.service = service;

    service.sampleSize$.subscribe((size) => {
      if (service.state !== TRANSFORMER_STATE.EDITING) {
        service.state = TRANSFORMER_STATE.EDITING;
      }
    });
    dataService.gridData$.subscribe((data) => {
      if (data) {
        service.totalRows = data.page.totalRows;
      }
    });
  }

  public describe(xform: Transform) {
    const d: any = xform.details;
    switch (xform.transformType as TRANSFORM_TYPE) {
      case TRANSFORM_TYPE.SAMPLE_DATA:
        return `Sampled ${d.sampleSize} rows`;
      default:
        throw new Error("Incompatible transform type for Column Types transform: " + xform.transformType);
    }
  }

  protected createSavePayload(): TransformDetails {
    return new SampleTransformDetails({ sampleSize: this.service.sampleSize });
  }

  protected initFromTransform(xform: Transform) {
    if (xform.transformType !== TRANSFORM_TYPE.SAMPLE_DATA) {
      throw new Error("Incompatible transform details for Sample transformer: " + xform.transformType);
    }
    const d = <any>xform.details;
    this.service.sampleSize = d.sampleSize;
  }
}
